import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoveLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5645 11.6016C12.0654 11.6016 11.7373 11.2598 11.7373 10.7539C11.7373 10.4805 11.7646 10.1797 11.7646 9.7627C11.7646 7.65039 11.0059 6.7959 8.91406 6.7959H4.69629L3.08984 6.7002L4.92871 8.36133L6.45312 9.89941C6.61035 10.0498 6.71289 10.2617 6.71289 10.5078C6.71289 10.9727 6.36426 11.3213 5.87207 11.3213C5.66016 11.3213 5.44824 11.2324 5.27051 11.0547L0.786133 6.57715C0.615234 6.41309 0.512695 6.17383 0.512695 5.94141C0.512695 5.70898 0.615234 5.47656 0.786133 5.30566L5.25684 0.834961C5.44824 0.650391 5.66016 0.561523 5.87207 0.561523C6.36426 0.561523 6.71289 0.910156 6.71289 1.375C6.71289 1.62109 6.61035 1.82617 6.45312 1.9834L4.92871 3.52148L3.09668 5.18262L4.69629 5.08691H9.03711C12.1406 5.08691 13.4805 6.57715 13.4805 9.72852C13.4805 10.125 13.4668 10.4941 13.4121 10.8086C13.3437 11.1846 13.1045 11.6016 12.5645 11.6016Z",
		fill: "currentColor"
	})
});
export default SvgMoveLeft;
